<template>
  <div>
    <div class="row" style="padding-bottom: 10px">
      <div class="col-md-2">
        <label for="starDate">{{$t('Tarixdən')}}</label>
        <el-date-picker size="small" id="starDate" format="dd.MM.yyyy" type="date" :clearable="false"
          v-model="item.startDate">
        </el-date-picker>
      </div>
      <div class="col-md-2">
        <label for="endDate">{{$t('Tarixədək')}}</label>
        <el-date-picker size="small" id="endDate" format="dd.MM.yyyy" type="date" :clearable="false"
          v-model="item.endDate">
        </el-date-picker>
      </div>
      <div class="col-md-8" style="padding-bottom: 10px">
        <label>{{$t('Axtarış_növü')}}</label>
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">
            <el-select style="width: 90%" size="small" v-model="item.searchType">
              <el-option :label="$t('--_Bütün_--')" :value="0"></el-option>
              <el-option :label="$t('Hadisə_nömrəsi')" :value="1"></el-option>
              <el-option :label="$t('SŞ_nömrəsi')" :value="2"></el-option>
              <el-option :label="$t('DQN')" :value="3"></el-option>
              <el-option :label="$t('İştirakçılara_görə')" :value="4"></el-option>
            </el-select>
            &nbsp;
            <el-select id="zbtStatus" @change="getData" style="width: 150px; min-width: 200px;"
              size="small" v-model="item.zbtStatus">
              <el-option :label="$t('--_Bütün_--')" :value="-1"></el-option>
              <el-option label="ZBT - Bəli" :value="1"></el-option>
              <el-option label="ZBT - Xeyr" :value="0"></el-option>
              <el-option label="ZBT - Qeyd olunmayıb" :value="2"></el-option>
            </el-select>
            &nbsp;
            <el-input size="small" @keyup.enter.native="clickSearch" :placeholder="$t('Axtar')"
              :disabled="item.searchType == 0" v-model="item.searchText">
              <template slot="prepend"> </template>
            </el-input>
            &nbsp;
            <el-button size="small" type="primary" icon="el-icon-search" @click="clickSearch"></el-button>
            &nbsp;
            <download-excel :fields="cellsForExport" :data="exportDataList" worksheet="My Worksheet" name="responses">
              <el-button size="small" @click="exportData" type="info"><i class="fa-solid fa-download"></i>
                {{$t('Export')}}
              </el-button>
            </download-excel>
          </div>
        </div>
      </div>

      <div class="col-md-8" style="padding-bottom: 10px">
        <div class="d-flex justify-content-start align-items-center">
          <div class="d-flex flex-row">
            <el-checkbox @change="getData" v-model="item.accidentStatus">Hadisəyə görə</el-checkbox>
            <el-checkbox @change="getData" v-model="item.claimStatus">İşə görə</el-checkbox>
            <el-checkbox @change="getData" v-if="item.claimStatus === true" v-model="item.paymentStatus">Ödəniş
              olunanlar</el-checkbox>
          </div>
          <!-- <div class="d-flex flex-row align-items-center" style="margin-left: 20px;">
            <label for="zbtStatus" style="margin-right: 10px;">ZBT Status:</label>
            <el-select id="zbtStatus" @change="getData" style="width: 200px; min-width: 200px;margin-bottom: 5px;"
              size="small" v-model="item.zbtStatus">
              <el-option :label="$t('--_Bütün_--')" :value="-1"></el-option>
              <el-option label="ZBT - Bəli" :value="1"></el-option>
              <el-option label="ZBT - Xeyr" :value="0"></el-option>
              <el-option label="ZBT - Qeyd olunmayıb" :value="2"></el-option>
            </el-select>
          </div> -->
        </div>

      </div>

    </div>

    <div class="row">
      <div class="col-12">
        <el-table :default-expand-all="true" v-loading="loading" :data="displayData" style="width: 100%">

          <el-table-column :label="$t('Hadisə_#')" v-if="item.accidentStatus" sortable
            prop="dispAccidentNumber" width="160">
          </el-table-column>
          <el-table-column  :label="$t('ZBT_(Q/K)')"  v-if="item.accidentStatus" sortable prop="zbtStatusComm" width="150">
          </el-table-column>
          <el-table-column :label="$t('İş_№')" v-if="item.claimStatus" sortable prop="dispClaimNumber" width="150">
          </el-table-column>

          <el-table-column :label="$t('Status')" width="300" prop="statusTypeName">
          </el-table-column>

          <el-table-column :label="$t('Status_Tarixi')" width="150" prop="statusDateStr">
          </el-table-column>
          <el-table-column :label="$t('Hadisə_tarixi')" sortable prop="accidentDateStr" width="150">
          </el-table-column>
          <el-table-column :label="$t('Müraciət_tarixi')" sortable prop="callDateStr" width="150">
          </el-table-column>
          <el-table-column :label="$t('Sığorta_növü')" v-if="item.accidentStatus" width="150" prop="insuranceTypeName">
          </el-table-column>
          <el-table-column :label="$t('Sığortalıdır')" v-if="item.accidentStatus" width="170" prop="participantTypeName">
          </el-table-column>
          <el-table-column :label="$t('Sığortalı_adı')" v-if="item.accidentStatus" prop="personName" width="300">
            <template slot-scope="scope">
              <span v-if="scope.row.participantType !== 3">
                {{ scope.row.personName }}
              </span>
              <span v-else>
                &nbsp;
              </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Sığorta_nömrəsi')" v-if="item.accidentStatus" prop="policyNumber" width="300">
          </el-table-column>
          <el-table-column :label="$t('Sürücü_adı')" v-if="item.accidentStatus" prop="partPersonName" width="300">
          </el-table-column>
          <el-table-column :label="$t('NV_Markasıl')" v-if="item.accidentStatus" width="200" prop="brandName">
          </el-table-column>
          <el-table-column :label="$t('NV_Modeli')" v-if="item.accidentStatus" width="200" prop="modelName">
          </el-table-column>
          <el-table-column :label="$t('NV_Marka/Model')" v-if="item.accidentStatus" width="300" prop="customBrandModel">
          </el-table-column>
          <el-table-column :label="$t('NV_Nömrəsi')" v-if="item.accidentStatus" width="150" prop="regNumber">
          </el-table-column>
          <el-table-column :label="$t('Köhnə_NV_nömrəsi')" v-if="item.accidentStatus" width="150" prop="oldRegNumber">
          </el-table-column>
          <el-table-column :label="$t('NV_Buraxılış_İli')" v-if="item.accidentStatus" width="150" prop="productionYear">
          </el-table-column>
          <el-table-column :label="$t('NV_ilkin_zərər_məbləği')" v-if="item.accidentStatus" width="150" prop="damageSum">
          </el-table-column>

          <el-table-column :label="$t('Filial')" prop="branchName" width="250">
          </el-table-column>
          <el-table-column label="ZBT (M/X)" v-if="item.claimStatus" sortable prop="zbtStatusClientService" width="150">
          </el-table-column>
          <el-table-column label="Ödəniş alan şəxs" v-if="item.claimStatus" width="300" prop="paymentReceivedPerson">
          </el-table-column>
          <el-table-column label="Ümumi zərər məbləği" v-if="item.claimStatus" width="150" prop="totalDamageSum">
          </el-table-column>
          <el-table-column label="Ödəniş məbləği" v-if="item.claimStatus" width="150" prop="paymentSum">
          </el-table-column>
          <el-table-column label="ZV Sığortalıdır?" v-if="item.claimStatus" width="150"
            prop="damagingParticipantTypeName">
          </el-table-column>
          <el-table-column label="ZV Sığorta növü" v-if="item.claimStatus" width="150" prop="damagingInsuranceTypeName">
          </el-table-column>
          <el-table-column label="ZV adı" v-if="item.claimStatus" width="250" prop="damagingPersonName">
          </el-table-column>
          <el-table-column label="ZV Sürücüsünün adı" v-if="item.claimStatus" width="250" prop="damagingPartPersonName">
          </el-table-column>
          <el-table-column label="ZV Sığorta nömrəsi" v-if="item.claimStatus" width="150" prop="damagingPolicyNumber">
          </el-table-column>
          <el-table-column label="ZV NV buraxılış ili" v-if="item.claimStatus" width="150"
            prop="damagingProductionYear">
          </el-table-column>
          <el-table-column label="ZV NV Markası" v-if="item.claimStatus" width="200" prop="damagingBrandName">
          </el-table-column>
          <el-table-column label="ZV NV Modeli" v-if="item.claimStatus" width="200" prop="damagingModelName">
          </el-table-column>
          <el-table-column label="ZV NV Marka/Model" v-if="item.claimStatus" width="300"
            prop="damagingCustomBrandModel">
          </el-table-column>
          <el-table-column label="ZV NV Nömrəsi" v-if="item.claimStatus" width="150" prop="damagingRegNumber">
          </el-table-column>
          <el-table-column label="ZV NV Köhnə nömrəsi" v-if="item.claimStatus" width="200" prop="damagingOldRegNumber">
          </el-table-column>
          <el-table-column label="ZV NV ilkin zərər məbləği" v-if="item.claimStatus" width="300"
            prop="damagingDamageSum">
          </el-table-column>

          <el-table-column label="ZÇ Sığortalıdır?" v-if="item.claimStatus" width="170"
            prop="victimParticipantTypeName">
          </el-table-column>

          <el-table-column label="ZÇ Sığorta növü" v-if="item.claimStatus" width="150" prop="victimInsuranceTypeName">
          </el-table-column>
          <el-table-column label="ZÇ adı" v-if="item.claimStatus" width="300" prop="victimPersonName">
          </el-table-column>
          <el-table-column label="ZÇ Sürücünün adı" v-if="item.claimStatus" width="300" prop="victimPartPersonName">
          </el-table-column>
          <el-table-column label="ZÇ Sığorta nömrəsi" v-if="item.claimStatus" width="150" prop="victimPolicyNumber">
          </el-table-column>
          <el-table-column label="ZÇ NV buraxılış ili" v-if="item.claimStatus" width="150" prop="victimProductionYear">
          </el-table-column>
          <el-table-column label="ZÇ NV Markası" v-if="item.claimStatus" width="200" prop="victimBrandName">
          </el-table-column>
          <el-table-column label="ZÇ NV Modeli" v-if="item.claimStatus" width="200" prop="victimModelName">
          </el-table-column>
          <el-table-column label="ZÇ NV Marka/Model" v-if="item.claimStatus" width="300" prop="victimCustomBrandModel">
          </el-table-column>
          <el-table-column label="ZÇ NV nömrəsi" v-if="item.claimStatus" width="150" prop="victimRegNumber">
          </el-table-column>
          <el-table-column label="ZÇ NV köhnə nömrəsi" v-if="item.claimStatus" width="200" prop="victimOldRegNumber">
          </el-table-column>
          <el-table-column label="ZÇ NV ilkin zərər məbləği" v-if="item.claimStatus" width="250" prop="victimDamageSum">
          </el-table-column>


        </el-table>
        <div style="text-align: center">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="filter.page" :page-sizes="[10, 30, 50, 100, 200]" :page-size="filter.pagesize"
            layout="sizes, prev, pager, next" :total="totalRecords">
          </el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { DateToString, AddMonths, AddDays } from "../../services/helper";
  import {
    GetBtzAccidentsReport,
  } from "src/services/report";
  export default {
    data() {
      return {
        loading: false,
        data: [],
        exportDataList: [],
        totalRecords: 0,
        search: "",
        uid: this.$store.state.user.id,
        item: {
          startDate: null,
          endDate: null,
          searchType: 0,
          searchText: null,
          paymentStatus: false,
          accidentStatus: true,
          claimStatus: false,
          zbtStatus: -1,
          dataExport: 0
        },
        displayData: [],
        filter: {
          page: 1,
          pagesize: 50,
        },


      };

    },
    computed: {
      cellsForExport() {
        let cells = {
          'Hadisə tarixi': 'accidentDateStr',
          'Müraciət tarixi': 'callDateStr',
          'Status': 'statusTypeName',
          'Status Tarixi': 'statusDateStr',
          'Filial': 'branchName',

        };

        if (this.item.accidentStatus) {
          Object.assign(cells, {

            'Hadisə №': 'dispAccidentNumberExport',
            'ZBT (QK)': 'zbtStatusComm',
            'Sığortalı adı': 'personNameExport',
            'Sığorta nömrəsi': 'policyNumber',
            'Sürücü adı': 'partPersonName',
            'Sığorta növü': 'insuranceTypeName',
            'Sığortalıdır?': 'participantTypeName',
            'NV Markası': 'brandName',
            'NV Modeli': 'modelName',
            'NV Marka/Model': 'customBrandModel',
            'NV Nömrəsi': 'regNumber',
            'Köhnə NV nömrəsi': 'oldRegNumber',
            'NV Buraxılış İli': 'productionYear',
            'NV ilkin zərər məbləği': 'damageSum',
          });
        }

        if (this.item.claimStatus) {
          Object.assign(cells, {
            'İş №': 'dispClaimNumber',
            'ZBT (M/X)': 'zbtStatusClientService',
            'Ödəniş alan şəxs': 'paymentReceivedPerson',
            'Ümumi zərər məbləği': 'totalDamageSum',
            'Ödəniş məbləği': 'paymentSum',
            'ZV Sığortalıdır?': 'damagingParticipantTypeName',
            'ZV Sığorta növü': 'damagingInsuranceTypeName',
            'ZV Sığortalı adı': 'damagingPersonName',
            'ZV Sürücü adı': 'damagingPartPersonName',
            'ZV Sığorta nömrəsi': 'damagingPolicyNumber',
            'ZV NV buraxılış ili': 'damagingProductionYear',
            'ZV NV Markası': 'damagingBrandName',
            'ZV NV Modeli': 'damagingModelName',
            'ZV NV Marka/Model': 'damagingCustomBrandModel',
            'ZV NV Nömrəsi': 'damagingRegNumber',
            'ZV NV Köhnə nömrəsi': 'damagingOldRegNumber',
            'ZV NV ilkin zərər məbləği': 'damagingDamageSum',
            'ZÇ Sığortalıdır?': 'victimParticipantTypeName',
            'ZÇ Sığorta növü': 'victimInsuranceTypeName',
            'ZÇ Sığortalı adı': 'victimPersonName',
            'ZÇ Sürücü adı': 'victimPartPersonName',
            'ZÇ Sığorta nömrəsi': 'victimPolicyNumber',
            'ZÇ NV buraxılış ili': 'victimProductionYear',
            'ZÇ NV Markası': 'victimBrandName',
            'ZÇ NV Modeli': 'victimModelName',
            'ZÇ NV Marka/Model': 'victimCustomBrandModel',
            'ZÇ NV nömrəsi': 'victimRegNumber',
            'ZÇ NV köhnə nömrəsi': 'victimOldRegNumber',
            'ZÇ NV ilkin zərər məbləği': 'victimDamageSum',
          });
        }

        return cells;
      }
    },

    watch: {
      'item': {
        deep: true,
        handler() {
          if (!this.item.accidentStatus && !this.item.claimStatus) {
            this.item.accidentStatus = true;
          }
        }
      }
    },
    methods: {
      clickSearch() {
        this.filter.page = 1
        this.getData();
      },

      loadTime() {
        this.item.startDate = AddDays(new Date(), -6);
        this.item.endDate = AddDays(new Date(), +1);
      },
      exportData() {
        const params = {
          startDate: DateToString(this.item.startDate),
          endDate: DateToString(this.item.endDate),
          searchType: this.item.searchType,
          searchText: this.item.searchText,
          paymentStatus: this.item.paymentStatus,
          accidentStatus: this.item.accidentStatus,
          claimStatus: this.item.claimStatus,
          zbtStatus: this.item.zbtStatus,
          pageSize: this.filter.pagesize,
          pageNumber: this.filter.page,
          dataExport: this.item.dataExport
        };
        GetBtzAccidentsReport(params).then((response) => {
          this.loading = false;
          if (response.data) {
            this.data = response.data.map(item => ({
              ...item,
              personNameExport: item.participantType !== 3 ? item.personName : '',
              dispAccidentNumberExport: item.dispAccidentNumber ? `${item.dispAccidentNumber.toString().padStart(7, '0')}\u200B` : '',
            }));
            this.exportDataList = response.data;
          }
        }).finally(() => {
          this.item.dataExport = 0;
        });
      },

      getData() {
        this.loading = true;
        if (this.item.searchText === "") {
          this.item.searchText = null;
        }
        const params = {
          startDate: DateToString(this.item.startDate),
          endDate: DateToString(this.item.endDate),
          searchType: this.item.searchType,
          searchText: this.item.searchText,
          paymentStatus: this.item.paymentStatus,
          accidentStatus: this.item.accidentStatus,
          claimStatus: this.item.claimStatus,
          zbtStatus: this.item.zbtStatus,
          pageSize: this.filter.pagesize,
          pageNumber: this.filter.page,
          dataExport: this.item.dataExport
        };
        GetBtzAccidentsReport(params).then((response) => {
          this.loading = false;
          if (response.data) {
            this.data = response.data.map(item => ({
              ...item,
              personNameExport: item.participantType !== 3 ? item.personName : '',
              dispAccidentNumberExport: item.dispAccidentNumber ? `${item.dispAccidentNumber.toString().padStart(7, '0')}\u200B` : '',
            }));
            this.displayData = this.data;
            this.totalRecords = response.data?.[0].totalRecords;
          }
        });
      },
      handleCurrentChange(val) {
        this.filter.page = val;
        this.getData();
      },
      handleSizeChange(val) {
        this.filter.pagesize = val;
        this.getData();
      },
    },
    mounted() {
      this.loadTime();
      this.getData();
    },
  };
</script>

<style lang="css" scoped>
  .md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }
</style>